import { Collection } from 'es6/components/collection'
import { entryScriptName } from 'init/entry-script-name'
import { Defaults } from 'es-decorators'
import { NewsComment } from '../models/news-comment'

/**
 * Коллекция комментариев/ответов в карточке новости
 */
@Defaults({
  model: NewsComment,
  showAll: false,
  sort: '-created_at',
})
export class NewsComments extends Collection {
  /** @inheritDoc */
  url () {
    let newsIdUrlPart = this.news_id ? `&news_id=${this.news_id}` : '',
      perPage = this.showAll ? '&per-page=100' : '',
      sort = `&sort=${this.sort}`

    return `${entryScriptName}/api/v3/news-comment/?expand=user,comment_status${newsIdUrlPart}${perPage}${sort}`
  }

  /**
   * Добавление меты ответа к коллекции
   * @param {Object} response
   * @returns {Collection} response.items
   */
  parse (response) {
    this.state = response._meta
    return response.items
  }

  /**
   * @inheritDoc
   */
  initialize (data) {
    this.state = {}
    Collection.prototype.initialize.apply(this)
  }
}
